import { PropostaGruaDto } from './../../Models/proposta-grua.model';
import { Legislacio } from 'app/sections/configuracio/legislacions/Models/legislacio.model';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { GruaPendentsService } from './../../services/grua-pendents.service';
//import { InfraccioService } from '../../services/infraccions-service.service';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { Builder } from 'path-shared/models/builder';
import { PendentsComponent } from '../pendents/pendents.component';


@Component({
  selector: 'app-pendents-table',
  templateUrl: './pendents-table.component.html',
  styleUrls: ['./pendents-table.component.scss']
})
export class PendentsTableComponent implements OnInit, AfterViewInit, OnChanges  {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

   data: PropostaGruaDto[];
   //dataSource: CustomDataSource<Infraccio, InfraccioFilter>;
  // filter: InfraccioFilter = new InfraccioFilter('id', 'asc');
   displayedItems = [];
  highlightedRows = [];
  public tipusLegislacions = Array();

  @Input() selectButton: boolean;
 // @Input() updatedFilterData: InfraccioFilter;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<any> = new EventEmitter<string>();

  displayedColumns = ['codi', 'dataPropostaPda', 'data', 'dataFinalitzacio', 'idVehiclesFK', 'idAgentFk', 'idCalleFK', 'numCarrer', 'nombreCalle', 'valida', 'observacions', 'idInfraccioFK', 'numFotos', 'numPDA'];

  constructor( private gruaService: GruaPendentsService,
    private dialog: MatDialog) { }
  ngOnChanges(changes: SimpleChanges): void {
    throw new Error("Method not implemented.");
  }
  ngAfterViewInit(): void {
    //throw new Error("Method not implemented.");
  }

  ngOnInit() {
   this.loadData();
  }
  loadData() {
  //   this.gruaService.getAll().subscribe(results => {
  //     this.data = results;
  // });
  }
  refresh() {
    this.loadData();
  }
  onRowClicked(row) {
    if (row !== undefined && row !== null) {
      const ref = this.dialog.open(PendentsComponent, {
        width: '90%',
        height: '90%',
        closeOnNavigation: true,
        autoFocus: true,
        data: {
          'isDialog': true,
          'isReadOnly': false,
          'propostaGrua': row,
          'isProposta': true
        }
      });
      ref.afterClosed().subscribe(data =>{
        this.loadData();
      });
    }
  }

}
